// extracted by mini-css-extract-plugin
module.exports = {"CancelButton":"supply-and-scheduling__SyncCanceller__CancelButton","AlertBox":"supply-and-scheduling__SyncCanceller__AlertBox"};